import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Chart as ChartJS, registerables } from "chart.js";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import sectionService from "../../services/section-service";
import dashboardService from "../../services/dashboard-service";
import { registerLocale } from "react-datepicker";
import { es } from "date-fns/locale/es";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Divider, Spin } from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import BarchartDay from "../DashBoard/BarchartDay";
import moment from "moment/moment";
import { ToastContainer, toast } from 'react-toastify';
import Select from "react-select";


// Registrar componentes para Chart.js
ChartJS.register(...registerables);

const DashBoardProductivity = () => {


  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();


  const chartOneRef = useRef(null);
  const chartTwoRef = useRef(null);
  const chartThreeRef = useRef(null);
  const chartFourRef = useRef(null);


  const [showLineValues, setShowLineValues] = useState(true)
  const [expandChats, setExpandCharts] = useState(false)

  ///Aplicaciones por dia
  const [lotId, setLotId] = useState("0");
  const [sectionId, setSectionId] = useState("0");
  const [farmId, setFarmId] = useState("0");


  ////CONSTANTES DE COORRELACION////////////////////////
  const [total, setTotal] = useState(0) ///x value

  const [serieFirstHectareLot, setSerieFirstHectareLot] = useState([])
  const [listFirstHectareLot, setListFirstHectareLot] = useState([])


  registerLocale("es", es);
  const start_date = moment().subtract(1, 'month').startOf('month').toDate();
  const end_date = moment().subtract(1, 'month').endOf('month').toDate();


  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);


  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listSection, setListSection] = useState(escoja);


  const [serieAverageMonth, setSerieAverageMonth] = useState([])
  const [listAverageMonth, setListAvegareMonth] = useState([])


  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  const [options, setOptions] = useState([])
  const [selectedLotes, setSelectedLotes] = useState([]);
  const handleSelectChange = (selectedOptions) => {
    setSelectedLotes(selectedOptions || []);
  };

  // Estilos personalizados  
  const customStyles = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#CBEDFE",
      fontFamily: "inherit",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
    menu: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
  };
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////






  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
      //setValue("farm",0)
    }
  };

  const getListSection = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setFarmId(code);
    if (code == "0") {
      setListSection(escoja);
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
    }
  };

  const getLisLots = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setSectionId(code);
    if (code == "0") {
      setListLots(escoja);
      return;
    }
    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      const newOptions = sortedItems.map((lote) => ({
        value: lote._id,
        label: lote.name,
      }));
      setOptions(newOptions)
    }
  };




  /// PRIMERAS APLICACIONES POR LOTE
  const palmWithApplications = async (start_date, end_date) => {
    let start = moment(start_date).startOf("day").format('YYYY-MM-DD');
    let end = moment(end_date).endOf("day").format('YYYY-MM-DD');

    setSerieFirstHectareLot([])
    setListFirstHectareLot([])


    

    const result = await dashboardService.palmWithApplications(start, end, farmId, lotId, sectionId, selectedLotes);
    let listLot = [];
    let listAverage = [];
    if (result) {
      if (result.length == 0) {
        toast.info("No hay datos para mostrar", { autoClose: 1500 })
      }

      result.map((item) => {
        const lot = item.lotName.toLowerCase();
        const average = item.average.toFixed(2) * 100
        listLot.push(lot)
        listAverage.push(average)
      });

    }
    setSerieFirstHectareLot(listLot)
    setListFirstHectareLot(listAverage)
  };



  const averageByMonth = async () => {
  
      let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
      let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
      setSerieAverageMonth([])
      setListAvegareMonth([])
      const result = await dashboardService.palmWithApplicationsMonth(start, end, farmId, lotId, sectionId, selectedLotes);
      let listMonth = [];
      let listAverage = [];
      if (result) {
        result.map((item) => {
          const month = formatMonth(item._id);
          const average = item.average*100;
          listMonth.push(month)
          listAverage.push(average)
        });
      }
      setSerieAverageMonth(listMonth)
      setListAvegareMonth(listAverage)
    };



 const formatMonth = (yearMonth) => {
    const [year, month] = yearMonth.split("-").map(Number);
    const date = new Date(year, month - 1);
    return new Intl.DateTimeFormat("es-ES", { month: "short" }).format(date);
  };




  const loadDashBoard = () => {
    palmWithApplications(startDate, endDate)
    averageByMonth()
  };



  const cardStyle = {
    padding: "20px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    borderRadius: "10px",
    backgroundColor: "#fff",
  };

  const saveAsImage = (chartRef, title) => {
    if (chartRef.current) {
      const echartsInstance = chartRef.current.getEchartsInstance();
      const imgData = echartsInstance.getDataURL({
        type: "jpeg", // Formato de la imagen ('png', 'jpeg')
        pixelRatio: 2, // Relación de píxeles (mayor = imagen de mayor calidad)
        backgroundColor: "#fff", // Fondo de la imagen
      });

      // Crear un enlace para descargar la imagen
      const link = document.createElement("a");
      link.href = imgData;
      link.download = title; // Nombre del archivo
      link.click();
    }
  };



  useEffect(() => {
    getLisFarm();
    setValue("days", 165)
    setValue("weight", 40)
    //palmWithApplications()
  }, []);



  return (
    <div
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <ToastContainer />
      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Tasa de floración por lote</Divider>
      </div>
      <div className="row">
        <div className="col-12">
          <form
            className="form-react"
            defaultValue={{ weight: 40 }}

          >
            <div className="row mb-3">


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Finca</label>
                <select
                  className="form-control text-secondary"
                  {...register("farm")}
                  onChange={(e) => getListSection(e)}
                >
                  {listFarms.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Sección</label>
                <select
                  className="form-control text-secondary"
                  {...register("section")}
                  onChange={(e) => getLisLots(e)}
                >
                  {listSection.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>




              <div className="col-12 col-sm-2">
                <label className="text-secondary fw-bold">Desde</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control text-secondary"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </div>

              <div className=" col-12  col-sm-2">
                <label className="text-secondary fw-bold">Hasta</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control 
                text-secondary"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                />
              </div>




              <div className="col-12 col-sm-2">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <button
                  className="btn btn-primary w-100"
                  type="button"
                  onClick={() => loadDashBoard()}
                >
                  <i className="bi bi-search fa-lg m-2" /> Buscar
                </button>
              </div>



              <div className="col-12 col-sm-6">
                <label className="text-secondary fw-bold">Lotes</label>
                <Select
                  isMulti
                  options={options}
                  value={selectedLotes}
                  styles={customStyles}
                  onChange={handleSelectChange}
                  placeholder="Selecciona lotes..."
                />
              </div>







            </div>



          </form>
        </div>







        <div className={expandChats ? "col-12 mt-2" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle}>
            <BarchartDay
              chartRef={chartThreeRef}
              title="Tasa de floración"
              nameLine="Hectáreas"
              nameBar="Aplicaciones"
              symbol="%"
              subTitle="Porcentaje de palmas con al menos una aplicación vs palmas del lote"
              showSerieValue={showLineValues}
              decimals={0}
              valuesX={serieFirstHectareLot}
              valuesY={listFirstHectareLot}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartThreeRef, "productividad.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>


        <div className={expandChats ? "col-6 mt-2" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle}>
            <BarchartDay
              chartRef={chartOneRef}
              title={`Tasa de floración por mes`}
              nameLine="Hectáreas"
              symbol="%"
              nameBar="Aplicaciones"
              subTitle="Tasa de floración por mes"
              decimals={0}
              showSerieValue={showLineValues}
              valuesX={serieAverageMonth}
              valuesY={listAverageMonth}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartOneRef, "tasa-floracion-mes.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>






      </div>
    </div>
  );
};

export default DashBoardProductivity;
